import sectionTabs from './section-tabs.js'

(($) => {
    $.fn.sectionTabs = sectionTabs

    //if the tab section exists and there is a tab list
    if( $('.tabbed-section').length > 0 && $('.button-tabs').length > 0 ){
        $('.tabbed-section').sectionTabs();
    }

})(jQuery)


/**
 * Author: Ryan Hendrickson
 * Date: January 2024
 * Description: Used on /help-center to filter search results on page
 */

// grab elements
const noSearchResults = document.getElementById('no-search-results');
const searchForm = document.getElementById('help-center-search-form');
const searchBox = document.getElementById('help-center-search-keyword');
const departmentSelect = document.getElementById('department');
const searchClear = document.getElementById('help-center-search-clear');
const searchSite = document.getElementById('search-site');
const staffResults = document.getElementById('staff-results');
const staffCards = document.querySelectorAll('.js-staff-card');

// assign event listeners
searchForm.addEventListener('submit', (event) => {
    event.preventDefault();
    searchForText();
});

searchClear.addEventListener('click', () => {
    clearSearch();
    searchBox.value = '';
    departmentSelect.value = '';
});

departmentSelect.addEventListener('change', () => {
    searchForText();
});

function searchForText() {
    clearSearch();
    const searchContent = searchBox.value.trim().toLowerCase();
    const department = departmentSelect.value;

    if (!searchContent && !department) {
        return;
    }

    let countOfVisibleElems = 0;

    for (const staffCard of staffCards) {
        const matchesName = !searchContent || staffCard.dataset.name.includes(searchContent);
        const departments = staffCard.dataset.departments ? staffCard.dataset.departments.split(' ').filter(Boolean) : [];
        const matchesDepartment = !department || departments.includes(department);

        if (matchesName && matchesDepartment) {
            staffCard.classList.remove('hidden');
            countOfVisibleElems++;
        }
    }

    if (countOfVisibleElems === 0) {
        searchSite.href = `/search/?sitka_search=${searchContent}`;
        noSearchResults.classList.remove('hidden');
    } else {
        staffResults.classList.remove('hidden');
    }
}

function clearSearch() {
    noSearchResults.classList.add('hidden');
    staffResults.classList.add('hidden');

    for (const staffCard of staffCards) {
        staffCard.classList.add('hidden');
    }
}